import { useEffect, useState } from "react";
import { Newspaper, ExternalLink } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return `${d.getMonth() + 1}월 ${d.getDate()}일`;
};

// 카테고리 피드 상단 관련 뉴스 (더보기로 진입한 카테고리 페이지용)
export default function CategoryNews({ category }) {
  const [items, setItems] = useState([]);
  const [label, setLabel] = useState("");

  useEffect(() => {
    let alive = true;
    setItems([]);
    fetch(`${API_URL}/api/community-news/category/${category}?limit=12`)
      .then((r) => (r.ok ? r.json() : { articles: [] }))
      .then((d) => { if (alive) { setItems(d.articles || []); setLabel(d.label || ""); } })
      .catch(() => {});
    return () => { alive = false; };
  }, [category]);

  if (items.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl border border-stone-100 p-4 sm:p-5 mb-3" data-testid="category-news">
      <h3 className="font-serif text-[16px] text-stone-900 flex items-center gap-2 mb-3">
        <Newspaper className="w-4 h-4 text-burgundy-600" strokeWidth={2.2} /> {label} 관련 뉴스
      </h3>
      <div className="divide-y divide-stone-100">
        {items.map((n) => (
          <div key={n.id} className="flex items-start gap-2 py-2.5" data-testid={`category-news-${n.id}`}>
            <span className="shrink-0 mt-0.5 inline-flex items-center gap-0.5 text-[10px] font-bold text-burgundy-500 bg-burgundy-50 px-1.5 py-0.5 rounded">
              <Newspaper className="w-3 h-3" /> NEWS
            </span>
            <div className="min-w-0 flex-1">
              <a href={n.url} target="_blank" rel="noopener noreferrer" className="block text-[14px] font-medium text-stone-800 hover:text-burgundy-700 leading-snug">
                {n.korean_title}
              </a>
              {n.ai_summary && <p className="text-[12.5px] text-stone-500 leading-relaxed mt-0.5 line-clamp-1">{n.ai_summary}</p>}
              <div className="flex items-center gap-1.5 text-[11px] text-stone-400 mt-1">
                <span className="truncate max-w-[140px]">{n.source_name}</span>
                <span>·</span>
                <span>{fmtDate(n.published_date)}</span>
                <a href={n.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 text-burgundy-500 hover:text-burgundy-700 font-semibold ml-auto whitespace-nowrap">
                  원문 보기 <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
